import { getCurrentInstance, onBeforeUnmount, Ref, ref, watch } from "@vue/composition-api";
import { lockBodyScroll } from "@scrile/tools/dist/lib/Scrollhelpers";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useModal(value: Ref<boolean>, modal: boolean) {
  const element = ref<Element | null>(null);
  const vm = getCurrentInstance();
  const modalClose = (close: boolean = !modal) => {
    close && vm?.$emit("input", false);
  };

  watch(value, (value: boolean) => {
    if (value) {
      element.value = document.activeElement;
      if (element.value) {
        (element.value as HTMLElement)?.blur();
      }
    } else {
      if (element.value) {
        (element.value as HTMLElement).focus();
      }
      element.value = null;
    }
  });

  const unwatch = watch(value, lockBodyScroll);

  value.value && lockBodyScroll(value.value);

  onBeforeUnmount(() => {
    if (value.value) lockBodyScroll(false);
    emitter.emit(EVENTS.STATUS_HIDE);
    unwatch();
  });

  return { modalClose };
}
